import { CourseFilters } from '../courses-filter/courses-filter';
import { toast } from 'react-toastify';
import appApi from '../../../api/app-api';
import { ReportCoursesType } from '../../../api/types/reports/education/courses/report-courses.type';
import { displayErrorText } from '../../../api/errors/api-error-codes';

export const getCoursesListOperation = async (
  filters: CourseFilters,
  offset: number,
  limit: number,
  setLoading: (loading: boolean) => any,
  setCourses: (courses: ReportCoursesType[]) => any,
  setTotal: (total: number) => any,
) => {
  try {
    setLoading(true);
    const coursesRes = await appApi.getAllCoursesMetadata({
      ...filters,
      offset,
      limit,
    });
    if (coursesRes.data.errCode) {
      toast.warn(displayErrorText(coursesRes.data.errCode));
      setLoading(false);
      return;
    }

    const paginationResponse = coursesRes.data.body;

    // Ensure we have valid pagination response
    if (!paginationResponse) {
      setCourses([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    if (!Array.isArray(paginationResponse.data)) {
      console.error('Invalid data in pagination response:', paginationResponse);
      setCourses([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    setCourses(paginationResponse.data);
    const totalCount = paginationResponse.total ?? 0;
    setTotal(totalCount);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `getCoursesListOperation is failed with the filters: ${JSON.stringify(filters)} error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
